export const monetaryMask = (value: string | number) => {
  const onlyNumbers = String(value).replace(/[^\d\.]/g, ``);
  const formatedValue = new Intl.NumberFormat(`pt-BR`, {
    minimumFractionDigits: 2,
  }).format(Number(onlyNumbers));
  return formatedValue;
};
